import { Word } from "./Word";
import { Conjunction } from './Conjunction';
import { Proposition } from "./Proposition";

export class Verb extends Word {
    public perfect;
    public conjunctions: Array<Conjunction>;
    public propositions: Array<Proposition>;
    constructor(word:any) {
        super(word);
        this.perfect = word.perfect;
        var self = this;
        this.conjunctions = [];
        this.propositions = [];
        if (word.conjunctions) {
            Object.keys(word.conjunctions).forEach(function (key) {
                self.conjunctions.push(new Conjunction(word.conjunctions[key]))
            });
        }
    }
    hasConjunction() {
        return this.conjunctions.length > 0;
    }
    addProposition(propositionData: any): any {
        if (propositionData != null)
            this.propositions.push(new Proposition(propositionData));
    }
}
